import { render, staticRenderFns } from "./CoordinatingOffice.vue?vue&type=template&id=c1335fae&scoped=true"
import script from "./CoordinatingOffice.vue?vue&type=script&lang=js"
export * from "./CoordinatingOffice.vue?vue&type=script&lang=js"
import style0 from "./CoordinatingOffice.vue?vue&type=style&index=0&id=c1335fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1335fae",
  null
  
)

export default component.exports